import React from 'react'
import { IconProps } from './BaseIcon.model'
import { library } from '../Icon.library'
import { getV2Color } from '../../../../design-system/colors_v2'
import { isFwCssVariableColor } from '../../../../design-system/design-system.utils'

interface BaseIconProps extends IconProps {
  sizeInPx: number
}

const validColor = (color: IconProps['color']) => {
  if (!color) return undefined
  if (color === 'currentColor') return 'currentColor'
  return isFwCssVariableColor(color) ? `var(${color})` : getV2Color(color)
}

export const BaseIcon = React.forwardRef<SVGSVGElement, BaseIconProps>(
  ({ icon, color, sizeInPx = 24, rotate = 0, testId = `icon-${icon}`, title }, ref) => {
    const svg = getSvg(icon)
    const [x1, y1, x2, y2] = svg.view.split(' ')

    return (
      <svg
        ref={ref}
        viewBox={svg.view}
        height={`${sizeInPx}px`}
        width={`${sizeInPx}px`}
        data-test-id={testId}
        xmlns="http://www.w3.org/2000/svg"
      >
        {title && <title>{title}</title>}
        <g
          fill={validColor(color)}
          dangerouslySetInnerHTML={{ __html: svg.path }}
          transform={`rotate(${rotate} ${(x2 - x1) / 2} ${(y2 - y1) / 2})`}
        />
      </svg>
    )
  },
)

const getSvg = (icon) => {
  const svg = library[icon]
  return svg ? svg : library.default
}
